import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { LibraryService } from '../providers/library.services';
import { Library } from "../../common/models/library";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LibraryResolver implements Resolve<Library> {
    constructor(
        private libraryService: LibraryService,
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<Library> {

      if (+route.params['libraryId']) {
        return this.libraryService.get(route.params['organizationCode'], +route.params['libraryId']);
      } else {
        return this.libraryService.getByOrganizationCode(route.params['organizationCode']);
      }

    }
}
